import { NextSpecial } from "@/data/v2/models/autoplay";
import { getApiClient } from "@punchup/utils";

/**
 * Fetches the ranked "what plays next" queue for a special on the comedian page.
 *
 * @param specialId        the currently-playing special.
 * @param sessionPlayedIds prior specials played this session, oldest→newest
 *                         (the current special is appended server-side).
 * @param limit            max results (server clamps to 1..25).
 */
export async function getNextSpecials(
  specialId: string,
  sessionPlayedIds: string[] = [],
  limit?: number
): Promise<NextSpecial[]> {
  const params = new URLSearchParams();
  if (sessionPlayedIds.length > 0) {
    params.set("session", sessionPlayedIds.join(","));
  }
  if (limit !== undefined) {
    params.set("limit", String(limit));
  }
  const query = params.toString();

  const response = await getApiClient().get<{ data: NextSpecial[] }>(
    `/api/v2/user/specials/${encodeURIComponent(specialId)}/next${
      query ? `?${query}` : ""
    }`
  );
  return response.data;
}
